import DiscountBanner from "./DiscountBanner";
import FailedPaymentBanner from "./FailedPaymentBanner";
import MemorialDayBanner from "./MemorialDayBanner";
import ValueMomentUpsell from "./ValueMomentUpsell";

const NotificationBanners = (): JSX.Element | null => {
  return (
    <>
      <DiscountBanner />
      <MemorialDayBanner />
      <FailedPaymentBanner />
      <ValueMomentUpsell />
    </>
  );
};

export default NotificationBanners;
